module.exports = __webpack_public_path__ + "img/Target Your Resources.a5f32804.png";